import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoGreen24 } from "constants/icons";
import { Menu, X } from "lucide-react";
import "./styles.css";

type NavLink = {
  label: string;
  onClick: () => void;
};

type NavbarProps = {
  navLinks?: NavLink[];
  actions?: ReactNode;
  mobileActions?: ReactNode;
  onLogoClick?: () => void;
  sticky?: boolean;
};

const AuthNavbar = ({ navLinks, actions, mobileActions, onLogoClick, sticky }: NavbarProps) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    } else {
      navigate("/");
    }
  };

  return (
    <nav className={`auth-nav ${sticky ? "auth-nav--sticky" : ""}`}>
      <div className="auth-nav-inner">
        <div className="auth-nav-logo" onClick={handleLogoClick}>
          <img src={logoGreen24} alt="OneLeague" />
          <span className="auth-nav-brand">OneLeague</span>
        </div>

        {navLinks && navLinks.length > 0 && (
          <div className={`auth-nav-links ${mobileMenuOpen ? "auth-nav-links--open" : ""}`}>
            <div className="auth-nav-links-center">
              {navLinks.map((link, i) => (
                <button
                  key={i}
                  type="button"
                  className="auth-nav-link"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    link.onClick();
                  }}
                >
                  {link.label}
                </button>
              ))}
            </div>
            {mobileActions && (
              <div className="auth-nav-actions-mobile">{mobileActions}</div>
            )}
          </div>
        )}

        {actions && (
          <div className="auth-nav-actions">{actions}</div>
        )}

        {navLinks && navLinks.length > 0 && (
          <button
            type="button"
            className="auth-nav-hamburger"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}
      </div>
    </nav>
  );
};

export const AuthFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="auth-footer">
      <div className="auth-footer-inner">
        <div className="auth-footer-logo">
          <img src={logoGreen24} alt="OneLeague" />
          <span>OneLeague</span>
        </div>
        <div className="auth-footer-links">
          <button type="button" className="auth-footer-link" onClick={() => navigate("/terms")}>
            Terms &amp; Conditions
          </button>
          <button type="button" className="auth-footer-link" onClick={() => navigate("/privacy")}>
            Privacy Policy
          </button>
        </div>
        <p className="auth-footer-copy">&copy; {new Date().getFullYear()} OneLeague. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default AuthNavbar;
